/**
 * テナントユーザー
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/users`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      contractor_name: null,
      tenant_name: null,
      user_name: null,
      unlinked_only: true,
    },
  }
}

const tenantUser = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * ユーザー一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param contractor_name
     * @param tenant_name
     * @param user_name
     * @param unlinked_only  
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { contractor_name, tenant_name, user_name, unlinked_only, page }) {
      dispatch('saveCondition', { contractor_name: contractor_name, tenant_name: tenant_name, user_name: user_name, unlinked_only: unlinked_only })
      const params = { contractor_name: state.condition.contractor_name, tenant_name: state.condition.tenant_name, user_name: state.condition.user_name, unlinked_only: state.condition.unlinked_only, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.ADMIN_TENANT_USER, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { contractor_name, tenant_name, user_name, unlinked_only }) {
      const _contractor_name = (contractor_name !== undefined) ? contractor_name : state.condition.contractor_name
      const _tenant_name = (tenant_name !== undefined) ? tenant_name : state.condition.tenant_name
      const _user_name = (user_name !== undefined) ? user_name : state.condition.user_name
      const _unlinked_only = (unlinked_only !== undefined) ? unlinked_only : state.condition.unlinked_only
      const params = { contractor_name: _contractor_name, tenant_name: _tenant_name, user_name: _user_name, unlinked_only: _unlinked_only }
      commit(types.ADMIN_TENANT_USER_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_TENANT_USER_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_TENANT_USER_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_TENANT_USER_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_TENANT_USER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_TENANT_USER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_TENANT_USER_CONDITION] (state, { params }) {
      state.condition.contractor_name = params.contractor_name
      state.condition.tenant_name = params.tenant_name
      state.condition.user_name = params.user_name
      state.condition.unlinked_only = params.unlinked_only
    }
  },
}

export default tenantUser

